
import Vue from 'vue'
import { SetResponsePropsByIds } from '@/entities/Response'
import GetUnreadUseCase from '@/usecases/notification/GetUnreadUseCase'
import GetTalkUseCase from '@/usecases/talk/GetTalkUseCase'
import GetRoomUseCase from '@/usecases/room/GetRoomUseCase'
import GetMeUseCase from '@/usecases/auth/GetMeUseCase'

const component = Vue.extend({
  async fetch() {
    await this.fetch()
  },
  mounted() {
    this.talk()
    this.appointment()
    this.message()
    this.refresh()
  },
  beforeDestroy() {
    this.$echo.leave('room.talk')
    this.$echo.leave(`appointment.read.${this.App.user.current?.id}`)
    this.$echo.leave(`appointment.send.${this.App.user.current?.id}`)
    this.$echo.leave(`user.refresh.${this.App.user.current?.id}`)
  },
  methods: {
    fetch() {
      setTimeout(async () => {
        this.App.notification.unread = await new GetUnreadUseCase(this.App).execute()
      }, 1000)
    },
    talk() {
      this.$echo.channel('room.talk').listen('Room.Talk', async (e: any) => {
        if (this.$route.name === 'room-id' && this.$route.params.id === e.room_id) {
          this.App.talk.data = SetResponsePropsByIds(
            this.App.talk.data,
            await new GetTalkUseCase(this.App).execute(this.$route.params.id, e.talk_id)
          )
        } else if (e.talker_id === this.App.user.current?.id) {
          this.App.room.data = SetResponsePropsByIds(
            this.App.room.data,
            await new GetRoomUseCase(this.App).execute(e.room_id)
          )
          await this.fetch()
        }
      })
    },
    appointment() {
      this.$echo.channel(`appointment.read.${this.App.user.current?.id}`).listen('Appointment.Read', () => {
        console.log(`appointment.read.${this.App.user.current?.id}`)
        this.fetch()
      })
      this.$echo.channel(`appointment.send.${this.App.user.current?.id}`).listen('Appointment.Send', () => {
        console.log(`appointment.send.${this.App.user.current?.id}`)
        this.fetch()
      })
    },
    message() {
      this.$echo.channel(`message.read.${this.App.user.current?.id}`).listen('Message.Read', () => {
        this.fetch()
      })
      this.$echo.channel(`message.send.${this.App.user.current?.id}`).listen('Message.Send', () => {
        this.fetch()
      })
    },
    refresh() {
      this.$echo.channel(`user.refresh.${this.App.user.current?.id}`).listen('User.Refresh', async () => {
        await new GetMeUseCase(this.App).execute()
        if (this.App.user.current?.flags?.locked) {
          this.$router.push({ name: 'order' })
        }
      })
    }
  }
})

Vue.component('MAppNotification', component)
export default component
